const { default: axios } = require('axios');

const { default: getParamByName } = require('./utilities/getParamByName');

const getPermalinkFromParams = () => {
  return getParamByName('permalink');
};

const parsePermalinkFromEncoded = (encodedPermalink) => {
  const decodedPermalinkString = atob(encodedPermalink);
  console.log('decodedPermalinkString', decodedPermalinkString);
  const permalinkItems = decodedPermalinkString.split('||').map(itemString => {
    const [handle, selectedOptions, quantity] = itemString.split('|');
    return {
      handle,
      selectedOptions: JSON.parse(selectedOptions || '{}'),
      quantity,
    };
  });
  return permalinkItems;
};

const actionPermalinkItems = async (items) => {
  /* Expects an array of:
  {
    handle
    selectedOptions
    quantity
  }
  */

  console.log('actionPermalinkItems', items);

  const variantIdFromItem = async (item) => {

    try {

      const { handle, selectedOptions, quantity } = item;
      let productData = await axios.get(`/products/${ handle }.json`);
      productData = productData?.data?.product;

      if (!productData) {
        console.error(`Product not found or unavailable`);
        return null;
      }

      const { options, variants, product_type: productType } = productData;

      // console.log(selectedOptions);

      const variant = variants.find(v => {
        return selectedOptions.every((option, i) => {
          const { name, value } = option;
          // console.log('name, value', name, value);
          const optionName = options[i]?.name;
          // console.log('optionName', optionName);
          const optionAttr = `option${ i + 1 }`;
          // console.log('optionAttr', optionAttr);
          // console.log('v[optionAttr]', v[optionAttr]);

          if (productType === 'Gift Cards' && name.toLowerCase().includes('denomination')) {
            return stripCurrency(v[optionAttr]) === stripCurrency(value);
          }

          return v[optionAttr] === value;
        });
      });

      if (!variant?.id) {
        console.log(`Variant not found for product`);
          return null;
      }

      // console.log(variant);
      return variant.id;

    } catch (error) {
      console.log(`Error fetching product: ${error.message}`);
      return null;
    }
  };

  const handleGiftCardVariant = (data) => {
    const { selectedOptions } = data;

    const selectedValue = stripCurrency(selectedOptions[0]?.value);

    const variant = productData.variants.find(v => {
      const variantValue = stripCurrency(v.title);
      return variantValue === selectedValue;
    });

    return variant?.id;
  };

  const stripCurrency = (valueWithCurrency) => {
    return valueWithCurrency.replace(/[^0-9.]/g, ''); // Removes non-numeric characters
  };

  const variantIds = await Promise.all(items.map(item => variantIdFromItem(item)));
  // console.log(variantIds);

  const permalinkString = variantIds.map((vId, i) => {
    if (!vId) {
      return;
    }

    const { quantity } = items[i];

    return `${ vId }:${ quantity }`;

  }).filter(item => item).join(',');
  // console.log(permalinkString);

  const url = `/cart/${ permalinkString }`;
  console.log('url', url);

  window.location.href = url;
};

const doPermalink = () => {
  const encodedPermalink = getPermalinkFromParams();
  if (!encodedPermalink) {
    return false;
  }

  const permalinkItems = parsePermalinkFromEncoded(encodedPermalink);
  if (!permalinkItems?.length) {
    return false;
  }
  console.log('permalinkItems', permalinkItems);

  actionPermalinkItems(permalinkItems);
};

window.doPermalink = doPermalink;

module.exports = {
  doPermalink,
};
